import { Route, Routes } from "react-router-dom";
import { RoutesPaths } from "./constant";
import Dashboard from "../Pages/Dashboard";
import { Login } from "../Pages/Login";
import Categories from "../Pages/Categories";
import AddCategory from "../Pages/AddCategory";
import Stors from "../Pages/Stors";
import AddStore from "../Pages/AddStore";
import Users from "../Pages/Users";
import Chats from "../Pages/Chats";
import Profile from "../Pages/Profile";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import EditStore from "../Pages/EditStore";
import ViewStore from "../Pages/ViewStore";
import Banner from "../Pages/Banner";
import AddBanner from "../Pages/AddBanner";
import EditBanner from "../Pages/EditBanner";
import PromotionalBanner from "../Pages/PromotionalBanner";
import AddPromotionalBanner from "../Pages/AddPromotionalBanner";
import EditPromotionalBanner from "../Pages/EditPromotionalBanner";
import EditCategory from "../Pages/EditCategory";

export default function RouteComponent() {
  return (
    <>
      <Routes>
        <Route exact path={RoutesPaths.LOGIN} element={<PublicRoute><Login /></PublicRoute>} />
        <Route exact path={RoutesPaths.DASHBOARD} element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route exact path={RoutesPaths.CATEGORIES} element={<PrivateRoute><Categories /></PrivateRoute>} />
        <Route exact path={RoutesPaths.ADDCATEGORIES} element={<PrivateRoute><AddCategory /></PrivateRoute>} />
        <Route exact path={RoutesPaths.EDITCATEGORIES} element={<PrivateRoute><EditCategory /></PrivateRoute>} />
        <Route exact path={RoutesPaths.STORS} element={<PrivateRoute><Stors /></PrivateRoute>} />
        <Route exact path={RoutesPaths.ADDSTORS} element={<PrivateRoute><AddStore /></PrivateRoute>} />
        <Route exact path={RoutesPaths.EDITSTORS} element={<PrivateRoute><EditStore /></PrivateRoute>} />
        <Route exact path={RoutesPaths.VIEWSTORS} element={<PrivateRoute><ViewStore /></PrivateRoute>} />
        <Route exact path={RoutesPaths.USERS} element={<PrivateRoute><Users /></PrivateRoute>} />
        <Route exact path={RoutesPaths.CHATS} element={<PrivateRoute><Chats /></PrivateRoute>} />
        <Route exact path={RoutesPaths.PROFILE} element={<PrivateRoute><Profile /></PrivateRoute>} />
        <Route exact path={RoutesPaths.BANNER} element={<PrivateRoute><Banner /></PrivateRoute>} />
        <Route exact path={RoutesPaths.ADDBANNER} element={<PrivateRoute><AddBanner /></PrivateRoute>} />
        <Route exact path={RoutesPaths.EDITBANNER} element={<PrivateRoute><EditBanner /></PrivateRoute>} />
        <Route exact path={RoutesPaths.PROMOTIONALBANNER} element={<PrivateRoute><PromotionalBanner /></PrivateRoute>} />
        <Route exact path={RoutesPaths.ADDPROMOTIONALBANNER} element={<PrivateRoute><AddPromotionalBanner /></PrivateRoute>} />
        <Route exact path={RoutesPaths.EDITPROMOTIONALBANNER} element={<PrivateRoute><EditPromotionalBanner /></PrivateRoute>} />
      </Routes>
    </>
  );
}
